import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from '../redux/store';
import { getDashboard } from '../redux/slices/dashboard';
import useAuth from '../hooks/useAuth';
import { PATH_DASHBOARD } from '../routes/paths';

// components
import Iconify from './Iconify';

// sections
import { BookingWidgetSummary } from '../sections/@dashboard/general/booking';

// ----------------------------------------------------------------------

export default function FixedStatsPanel() {
  const { user } = useAuth();
  const { now } = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const companyId = user?.companyId;
    let intervalId;

    if (companyId) {
      dispatch(getDashboard(companyId));
      
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [dispatch, user?.companyId]);

  return (
    <Box
      className="painel-conversas-compacto"
      sx={{
        p: 0,
        width: '100%',
        mb: -1,

        '& .MuiCard-root': {
          padding: '12px 8px',
          alignItems: 'flex-start',
        },
        '& .MuiCard-root > div:nth-of-type(2)': {
          width: '40px',
          height: '40px',
          minWidth: '40px',
          marginTop: 0,
          marginBottom: 0,
          padding: '7px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 'auto 0',
          alignSelf: 'center',

          transform: 'translateY(4px)',
        },
        '& .MuiCard-root > div:nth-of-type(1)': {
          marginTop: '-8px',
          marginBottom: '-8px',
        },
        '& .MuiCard-root .MuiTypography-h2': {
          fontSize: '1.2rem',
          lineHeight: 1.2,
          marginBottom: '2px',
        },
        '& .MuiCard-root .MuiTypography-subtitle2': {
          fontSize: '0.65rem',
          lineHeight: 1.2,
          marginTop: 0,
        },
        '& .MuiCard-root .MuiBox-root > .MuiTypography-subtitle2': {
          fontSize: '0.65rem',
          padding: '0px 0',
        },
      }}
    >
      <Grid container spacing={1.5}>
        {/* Card 1: Na Fila / In Queue */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          onClick={() => {
            navigate(PATH_DASHBOARD.calls.id.replace(':id', 'queue'));
          }}
          style={{ cursor: 'pointer' }}
        >
          <Box sx={{ paddingY: 0 }}>
            <BookingWidgetSummary
              title="Na fila"
              total={now?.counts?.inQueue ?? 0}
              icon={<Iconify width={24} height={24} icon={'fa-solid:clock'} />}
              time={now?.responseTimes?.inQueue ?? 0}
              color="rgba(154, 109, 80, 0.86)"
            />
          </Box>
        </Grid>

        {/* Card 2: Atendimento / Ongoing */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          onClick={() => {
            navigate(PATH_DASHBOARD.calls.id.replace(':id', 'attendance'));
          }}
          style={{ cursor: 'pointer' }}
        >
          <Box sx={{ paddingY: 0 }}>
            <BookingWidgetSummary
              title="Atendimento"
              total={now?.counts?.ongoing ?? 0}
              icon={<Iconify width={24} height={24} icon={'fa6-solid:headset'} />}
              time={now?.responseTimes?.ongoing ?? 0}
              color="rgba(49, 105, 199, 0.86)"
            />
          </Box>
        </Grid>

        {/* Card 3: BOT / In IMR */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          onClick={() => {
            navigate(PATH_DASHBOARD.calls.id.replace(':id', 'ura'));
          }}
          style={{ cursor: 'pointer' }}
        >
          <Box sx={{ paddingY: 0 }}>
            <BookingWidgetSummary
              title="BOT"
              total={now?.counts?.inIMR ?? 0}
              icon={<Iconify width={24} height={24} icon={'fa-solid:robot'} />}
              time={now?.responseTimes?.inIMR ?? 0}
              color="rgba(121, 91, 165, 0.86)"
            />
          </Box>
        </Grid>

        {/* Card 4: Pendentes / Pending */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          onClick={() => {
            navigate(PATH_DASHBOARD.calls.id.replace(':id', 'pending'));
          }}
          style={{ cursor: 'pointer' }}
        >
          <Box sx={{ paddingY: 0 }}>
            <BookingWidgetSummary
              title="Pendentes"
              total={now?.counts?.pending ?? 0}
              icon={<Iconify width={24} height={24} icon={'eva:alert-triangle-fill'} />}
              text="Retorno Automatico"
              color="rgba(154, 154, 154, 0.86)"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
